import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';

var fsalesForm = function (classname, form) {
  const $form = $(form);
  // Presetted and Fetched constants
  const signUpApiUrl = $form.data('signup-url');
  const postData = [];
  const currentLoc = SiteUtilities.getCurrentLocation();
  const $signUpBtn = $form.find('.button');
  const emailid = $form.find('.email-form').val();
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();

  // Setting Values
  $signUpBtn.addClass('button--loading').attr('disabled', 'disabled');

  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(emailid, fmAssetId, tacticId);

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  if (sessionObj) {
    sessionObj.composite_stitching_key = compositeKey;
    sessionObj.allocadia_asset_id = fmAssetId;
    sessionObj.allocadia_tactic_id = tacticId;

    sessionObj.ga_client_id = `${SiteUtilities.getGAClientID()}:${compositeKey}`;
  }

  if (!SiteUtilities.GDPRFunctionalCookieDisabled()) {
    // Binding maxmind_session
    sessionObj.location = LocationUtilities.getGeoLocation();
  }
  const sessionJSON = JSON.stringify(sessionObj);

  // Bind username and fs_cookie
  const username = $form.find('.first-name-form').val() + ' ' + $form.find('.last-name-form').val();
  let fsCookie = '';
  try {
    fsCookie = freshsales.anonymous_id;
  } catch (exception) {
    SiteUtilities.log(
      'Freshsales session exception.',
      'warning',
      'submitHandlers.fsalesForm (fsCookie - Catch Exception)',
      0,
      exception
    );
  }

  // Build postData
  postData.push(
    { name: 'first_name', value: $form.find('.first-name-form').val() },
    { name: 'last_name', value: $form.find('.last-name-form').val() },
    { name: 'user_email', value: emailid },
    { name: 'account_name', value: $form.find('.company-form').val() },
    { name: 'account_domain', value: $form.find('.domain-form').val() },
    { name: 'mobile_number', value: $form.find('.phone-form').val() },
    { name: 'session_json', value: sessionJSON },
    { name: 'product', value: 'Freshsales' },
    { name: 'source', value: 'Inbound' },
    { name: 'medium', value: 'EinsteinAdCampaign' },
    { name: 'campaign', value: 'FSEINSTEINCamp' },
    { name: 'first_referrer', value: (isExternalIframeSignup && currentReferrer) ? currentReferrer : (Cookie.get('fw_fr') || currentLoc) },
    { name: 'first_landing_url', value: Cookie.get('fw_flu') || '' },
    { name: 'noscript', value: $('form input[name="noscript"]') ? $('form input[name="noscript"]').value : '' },
    { name: 'user_name', value: username },
    { name: 'fs_cookie', value: fsCookie }
  );

  // Handling growsumo data
  var gsdata = {
    first_name: $form.find('.first-name-form').val(),
    email_id: emailid,
    domain_name: $form.find('.domain-form').val()
  };
  localStorage.setItem('gsdata', JSON.stringify(gsdata));

  // Ajax Call
  $.ajax({
    url: signUpApiUrl,
    type: 'POST',
    data: JSON.stringify(postData),
    dataType: 'json',
    crossDomain: true,
    accept: 'application/json; charset=UTF-8',
    contentType: 'application/json; charset=UTF-8',
    success: (response, textStatus, jqXHR) => {
      const status = jqXHR.status;
      const isSuccess = (status >= 200 && status < 300) || (status === 304);
      if (isSuccess) {
        response.composite_stitching_key = compositeKey;
        fsalesSignupFormSuccess($form, response);
      } else {
        const responseObject = {
          jqXHR,
          textStatus,
          response
        };
        SiteUtilities.classifyStatusCode(status, 'Freshsales Signup API call succeeded - Received Error Response', 'fsalesForm', responseObject);
        $signUpBtn.removeClass('btn-loading').val('Retry').removeAttr('disabled');
      }
    },
    error: (jqXHR, textStatus, err) => {
      const responseObject = {
        jqXHR,
        textStatus,
        err
      };
      SiteUtilities.classifyStatusCode(jqXHR.status, 'Freshsales Signup API call Failed', 'fsalesForm', responseObject);
      $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
    }
  });
};

const fsalesSignupFormSuccess = ($form, response, alohaV2 = false) => {
  const emailid = $form.find('.email-form').val();
  const emailHash = SiteUtilities.getShaHash(emailid);
  const redirect = $form.attr('data-redirect');
  const redirectAds = $form.attr('data-redirect-ads');
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  let redirectUrl = '#';
  let accountId = '';
  let signupResponse;
  let isSignupClosed;

  if (alohaV2) {
    signupResponse = response['product_signup_response'];
    redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');
    accountId = (signupResponse.account && signupResponse.account.id) ? signupResponse.account.id : null;
  } else {
    signupResponse = response['signup_status'];
    isSignupClosed = signupResponse.is_closed;
    redirectUrl = signupResponse.url;
  }

  // Send data to google analytics
  try {
    var trackers = ga.getAll();
    for (var t = 0; t < trackers.length; t++) {
      if (trackers[t].get('trackingId') === 'UA-78569416-1') {
        var trackerName = trackers[t].get('name');
        ga(trackerName + '.set', {
          page: `${SiteUtilities.removeTrailingSlashEnd(window.location.href)}/thank-you/?redirect=${redirectUrl}&ehash=${emailHash}`,
          title: 'Signup Complete',
          dimension1: $form.find('.domain-form').val() + '.freshsales.io',
          dimension8: SiteUtilities.sanitizeGACookie(SiteUtilities.getGAClientID())
        });
        ga(trackerName + '.send', 'pageview', {
          page: `${SiteUtilities.removeTrailingSlashEnd(window.location.href)}/thank-you/?redirect=${redirectUrl}&ehash=${emailHash}`,
          title: 'Signup Complete'
        });
        break;
      }
    }
  } catch (e) {
    console.log(e);
  }
  const geoLocation = LocationUtilities.getGeoLocation();
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: $form.find('.first-name-form').val(),
      last_name: $form.find('.last-name-form').val(),
      email: $form.find('.email-form').val(),
      phone: $form.find('.phone-form').val() || '',
      company: $form.find('.company-form').val(),
      // Please dont forget the !
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fsalesfirstreferrer: Cookie.get('fw_flu') || '',
        cf_fsalessignupreferrer: window.location.href || '',
        cf_fsalescustomerstatus: 'Trial',
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      },
      domainUrl: redirectUrl,
      product: 'Freshsales',
      accountId: accountId,
      composite_stitching_key: response.composite_stitching_key || null
    }
  };
  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshsales');
  if (SiteUtilities.GDPRFunctionalCookieDisabled()) {
    freshmarketerData.freshmarketerObject['country'] = geoLocation ? geoLocation.countryName : '';
  } else {
    freshmarketerData.freshmarketerObject['city'] = geoLocation ? geoLocation.cityName : '';
    freshmarketerData.freshmarketerObject['state'] = geoLocation ? geoLocation.regionName : '';
    freshmarketerData.freshmarketerObject['country'] = geoLocation ? geoLocation.countryName : '';
    freshmarketerData.freshmarketerObject['zipcode'] = geoLocation ? geoLocation.zipCode : '';
  }
  // Trigger trackingCompleted only after both the freshmarketer functions are completed
  jQuery.when(
    SiteUtilities.freshmarketerPost(freshmarketerData, false, $form)
  ).then(function () {
    jQuery('body').trigger('trackingCompleted');
  });

  // Code to add a param to the thank-you page for referral program sign-ups
  const utmSource = SiteUtilities.getParameterByName('utm_source');
  let referralParam = '';
  if (utmSource && utmSource === 'invitereferrals') {
    referralParam = '&referral_sign_up=' + encodeURIComponent('true') + '&email=' + encodeURIComponent(emailid) + '&username=' + encodeURIComponent($form.find('.first-name-form').val() + ' ' + $form.find('.last-name-form').val());
  }

  const planName = SiteUtilities.getParameterByName('plan');
  // Storing the redirect url locally to avoid XSS from url.
  (planName && planName !== '') ? localStorage.setItem('redirect_url', redirectUrl + '?plan=' + planName) : localStorage.setItem('redirect_url', redirectUrl);

  // Code to add a param to the thank-you page for plan-signups (PL-ADS)
  jQuery('body').on('trackingCompleted', () => {
    let thankYouRedirect;
    if (planName && planName !== '') {
      const planParam = '&plan=' + encodeURIComponent(planName);
      thankYouRedirect = !(isSignupClosed) ? `${redirectAds}/?${planParam}&redirect=${encodeURIComponent(redirectUrl)}${planParam}${referralParam}&ehash=${emailHash}` : '/signup/closed/';
    } else {
      thankYouRedirect = !(isSignupClosed) ? `${redirect}/?redirect=${encodeURIComponent(redirectUrl)}${referralParam}&ehash=${emailHash}` : '/signup/closed/';
    }
    if (!isSignupClosed && isExternalIframeSignup) {
      thankYouRedirect = thankYouRedirect + '&post_to_partner=true';
      if (currentReferrer) {
        thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
      }
    }
    window.location.href = thankYouRedirect;
  });
};

// Freshsales Classic Account
const fsalesClassicAccountLogin = (domain, loginUrl) => {
  const error = {};
  const getData = (url, resolve, reject) => {
    jQuery.getJSON(url).done(
      (data) => {
        const { is_available: isAvailable } = data || {};
        if (isAvailable === false) return resolve(`https://${domain}.freshsales.io`);
        return reject(Object.assign(error, { status: 404 }));
      }
    ).fail(
      () => {
        return reject(Object.assign(error, { status: 502 }));
      }
    );
  };

  return new Promise((resolve, reject) => {
    if (!domain) reject(Object.assign(error, { status: 400 }));
    getData(`${loginUrl || 'https://login.freshsales.io/domain_available?domain='}${domain}`, resolve, reject);
  });
};

export default {
  fsalesForm,
  fsalesSignupFormSuccess,
  fsalesClassicAccountLogin
};
